import baseUrl from "../utils/baseUrl";
import axios from "./api";

const getUserConfigsByUserId = async (id) => await axios.get(baseUrl + `/user-mechanic-configs/${id}`).then((response) => response.data);

const changeHideProducsPricesByUserId = async (id) => await axios.post(baseUrl + `/user-mechanic-configs/${id}/hide-products-prices`).then((response) => response.data);

export { getUserConfigsByUserId, changeHideProducsPricesByUserId };
